import { useTranslation } from 'react-i18next';

import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetGoodfellowQuery } from '@api/goodfellow.api';

export default function GoodfellowSelector(props: MultiSelectProps) {
  const { t } = useTranslation();
  const { data = [], isLoading } = useGetGoodfellowQuery();

  return (
    <MultiSelect
      label={t('selectors.goodfellow.label')}
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : t('selectors.goodfellow.placeholder')
      }
      data={data.map((goodfellow) => ({
        label: goodfellow.name,
        value: goodfellow.name,
      }))}
      disabled={isLoading}
      {...props}
    />
  );
}
